module.exports = __webpack_public_path__ + "static/media/IntroToSecurityEngineering.b4156c78.png";